import { render, staticRenderFns } from "./dr-file-input.vue?vue&type=template&id=512c29a2"
import script from "./dr-file-input.vue?vue&type=script&lang=js"
export * from "./dr-file-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports